import React from 'react';
import { Tooltip } from 'antd';
import cn from 'classnames';
import { cameraParentViews } from '../../constants';
import Loader from '../Loader/Loader';
import styles from './VideoContainer.module.scss';

const VideoContainer = ({
  containerId,
  fullScreen,
  setFullscreen,
  parentView,
  mainScreen,
  loading,
  className,
  children,
  onOverlayClick,
  overlayTooltip,
}) => {
  const handleClick = () => {
    setFullscreen(true);
  };

  const isInTable = parentView === cameraParentViews.table;
  const isPreview = !mainScreen && !fullScreen;
  const cover = (
    <div
      className={styles.cover}
      onClick={onOverlayClick}
    />
  );

  return (
    <div
      id={containerId}
      onClick={isInTable && isPreview ? handleClick : undefined}
      className={cn(styles.root, className, {
        [styles.fullScreen]: fullScreen,
        [styles.preview]: isPreview,
        [styles.round]: !fullScreen,
        [styles.inTable]: isInTable && isPreview,
      })}
    >
      <Loader loading={loading} />
      {overlayTooltip ? (
        <Tooltip
          title={overlayTooltip}
          placement="top"
        >
          {cover}
        </Tooltip>
      ) : (
        cover
      )}
      {children}
    </div>
  );
};

export default VideoContainer;
